<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="xinwentou1 w1200">
      <em>{{ infotitle }}</em>
    </div>
    <div class="news_list w1200" v-loading="qyloading">
      <h2 v-if="classifylist.length > 0" class="product-title-second">{{ infotitle }}的相关专题</h2>
      <ul v-if="classifylist.length > 0" class="product-cat-ul">
        <li class="product-cat-li" v-for="(item, index) in classifylist" :key="index">
          <router-link :to="{path: '/InfoList', query:{productclassifysid:item.id}}" target="_blank" :title="item.title" class="category-box">{{ item.title }}</router-link>
        </li>
      </ul>
      <h2 class="product-title-second">{{ infotitle }}的相关文章</h2>
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <router-link :to="{path: '/InfoDetail', query:{id:item.id}}" target="_blank" :title="item.title">
            <div class="padd clearfix">
              <div class="news_list_l">
                <el-image
                  :src="item.filename"
                  fit="fill"
                  style="width:130px;height:130px"
                  >
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/zwtp.jpg" width="130" height="130"/>
                  </div>
                </el-image>
              </div>
              <div class="news_list_r">
                <h3 class="atpresent_title">{{ item.title }}</h3>
                <div class="news_list_c clearfix">
                  <em><img src="">{{ item.addtime }}</em>
                  <em><img src=""> {{ item.hit }}次</em>
                </div>
                <div class="news_list_b" v-html="escapeHTML(item.content)"></div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="hxq_subpage">
      <pagination v-show="total>10" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getInfoList" />
    </div>
    <Footer/>
  </div>
</template>

<script>

import api from '@/api/resources'
import Header from '@/components/Resources/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import Pagination from '@/components/Pagination'

export default {
  name: 'InfoList',
  components: {
    Header,
    Navigationzj,
    Footer,
    Pagination
  },
  data () {
    return {
      api,
      infotitle: '',
      classifylist: [],
      list: [],
      listQuery: {
        limit: 10,
        order: 'order_num',
        sort: 'asc',
        moduleid: 2,
        state: 'home'
      },
      qyloading: false,
      total: 0
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    escapeHTML (untrusted) {
      return untrusted.replace(/<(?:.|\n)*?>/gm, '')
        .replace(/(&rdquo;)/g, '/"')
        .replace(/&ldquo;/g, '/"')
        .replace(/&mdash;/g, '-')
        .replace(/&nbsp;/g, '')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/<[\w\s"':=/]*/, '')
    },
    getInfoList () {
      if (this.$route.query.productclassifyid) {
        this.listQuery.productclassifyid = [parseInt(this.$route.query.productclassifyid)]
      } else if (this.$route.query.productclassifysid) {
        this.listQuery.productclassifysid = parseInt(this.$route.query.productclassifysid)
      } else if (this.$route.query.classifyid) {
        this.listQuery.classifyid = parseInt(this.$route.query.classifyid)
      } else if (this.$route.query.themeid) {
        this.listQuery.themeid = parseInt(this.$route.query.themeid)
      } else if (this.$route.query.labelid) {
        this.listQuery.labelid = parseInt(this.$route.query.labelid)
      }
      api.Query(this.listQuery).then(res => {
        this.list = res.items
        this.infotitle = res.infotitle.title
        this.classifylist = res.classifylist
        this.total = res.total
      })
    }
  }
}
</script>
<style scoped>
  .atpresent_title {
    font-weight: 600;
  }
  .product-title-second {
    padding-top: 40px;
    width: 100%;
    text-align: left;
    color: #333333;
    font-size: 20px;
    margin: 0;
    height: 30px;
    border-bottom: 1px solid #f3f3f3;
    font-weight: normal;
  }
  .product-cat-ul {
    padding-top: 15px;
    width: 100%;
    height: 130px;
    overflow-y: auto;
  }
  .product-cat-ul .product-cat-li {
    margin: 5px;
    display: inline-block;
  }
  .product-cat-ul .product-cat-li .category-box {
    display: block;
    width: 120px;
    height: 30px;
    text-align: center;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    line-height: 30px;
    font-size: 15px;
    cursor: pointer;
    text-decoration: none;
    color: #333;
  }
  .product-cat-ul .product-cat-li .category-box:hover {
    background-color: #5178b5;
    color: #fff;
  }
  .product-cat-ul::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .product-cat-ul::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #c1c1c1;
  }
  .product-cat-ul::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }
</style>



// WEBPACK FOOTER //
// src/view/resources/info_list.vue